// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';

// Components
import './components';

// Plugins
import './plugins';

// Sync router with store
import { sync } from 'vuex-router-sync';

//import colors from 'vuetify/es5/util/colors';
import colors from 'vuetify/lib/util/colors';
import vuedraggable from 'vuedraggable';

// Application imports
import App from './App';
import i18n from '@/i18n';
import router from '@/router';
import { createSessionNavigationGuard } from '@/router/session-navigation';
import store from '@/store';

// Additional imports
//import Axios from 'axios';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
import vuetify from './plugins/vuetify';
import VueApexCharts from 'vue-apexcharts';
import VueLottiePlayer from 'vue-lottie-player';
import * as VueGoogleMaps from 'gmap-vue';
import 'animate.css';
import VueGtag from 'vue-gtag';
import editor from '@tinymce/tinymce-vue';
import gallery from 'vue-cover-gallery';
import vue2Dropzone from 'vue2-dropzone';
import InstantSearch from 'vue-instantsearch';
import VueDOMPurifyHTML from 'vue-dompurify-html';
import { formatters } from './utils/formatters';
import { enums } from './utils/enums';
import { publicMediaUrl, validatePublicMediaBase } from '@/config/publicMedia';

//Stripe
import { StripeCheckout } from '@vue-stripe/vue-stripe';
Vue.component('StripeCheckout', StripeCheckout);

//Axios.defaults.withCredentials = true;

Vue.use(VueApexCharts);
Vue.use(VueLottiePlayer);
Vue.use(InstantSearch);
Vue.component('Apexchart', VueApexCharts);
Vue.component('Dropzone', vue2Dropzone);
Vue.use(VueDOMPurifyHTML, {
  default: {
    USE_PROFILES: { html: true },
  },
});

// Google Maps
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    /// / If you want to set the version, you can do so:
    // v: '3.26',
  },

  /// / If you intend to programmatically custom event listener code
  /// / (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  /// / instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  /// / you might need to turn this on.
  // autobindAllEvents: false,

  /// / If you want to manually install components, e.g.
  /// / import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  /// / Vue.component('GmapMarker', GmapMarker)
  /// / then disable the following:
  // installComponents: true,
});

// Sync store with router
sync(store, router);

// Make third party libraries available within app
//Vue.prototype.$http = Axios;
Vue.prototype.$formatters = formatters;
Vue.prototype.$enums = enums;
Vue.use(VueLodash, { lodash: lodash });
moment.tz.setDefault('UTC');
Vue.use(VueMoment, {
  moment,
});
Vue.use(require('vue-faker'), { locale: 'en_US' });
Vue.use(vuedraggable);
Vue.component('Draggable', vuedraggable);
Vue.component('Editor', editor);
Vue.component('Gallery', gallery);

const sampleWebsiteImages = {
  beachHouse: '1564013799919-ab600027ffc6',
  cabin: '1600585154340-be6161a56a0c',
  houseExterior: '1560518883-ce09059eeffa',
  meetingRoom: '1497366754035-f200968a6e72',
  listing: [
    '1600607687939-ce8a6c25118c',
    '1600566753190-17f0baa2a6c3',
    '1600585154526-990dced4db0d',
    '1616486338812-3dadae4b4ace',
    '1586023492125-27b2c045efd7',
    '1512917774080-9991f1c4c750',
    '1618221195710-dd6b41faaea6',
    '1600566753086-00f18fb6b3ea',
  ],
};

const sampleWebsiteImage = (type = 'listing', width = 1200, height = 600, seed = 0) => {
  const image = sampleWebsiteImages[type] || sampleWebsiteImages.listing;
  const id = Array.isArray(image) ? image[Math.abs(seed) % image.length] : image;

  return `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${width}&h=${height}&q=80`;
};

const publicMediaBase = validatePublicMediaBase(process.env.VUE_APP_S3_BUCKET, {
  required: process.env.NODE_ENV === 'production',
});

Vue.mixin({
  methods: {
    path(path) {
      return publicMediaUrl(path, publicMediaBase);
    },
    sampleWebsiteImage,
  },
});

Vue.config.productionTip = false;

// Env Variables
Vue.prototype.$api_url = process.env.VUE_APP_APIURL;
Vue.prototype.$publicPath = process.env.BASE_URL;
Vue.use(vuetify, {
  theme: {
    themes: {
      light: {
        primary: colors.indigo.accent1,
        success: colors.indigo.accent1,
        secondary: colors.grey.darken1,
        accent: colors.shades.black,
        error: colors.red.accent3,
      },
    },
  },
});

router.beforeEach(createSessionNavigationGuard(store));

// Google Analyics G-7MX44YX8YR <-- OLD G-6CFWRNXKS3 <-- NEW
Vue.use(
  VueGtag,
  {
    config: { id: 'G-7MX44YX8YR' },
  },
  router
);

/* eslint-disable no-new */
new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
